"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var space = _interopRequireWildcard(require("./space"));

var entry = _interopRequireWildcard(require("./entry"));

var asset = _interopRequireWildcard(require("./asset"));

var assetKey = _interopRequireWildcard(require("./asset-key"));

var contentType = _interopRequireWildcard(require("./content-type"));

var locale = _interopRequireWildcard(require("./locale"));

var tag = _interopRequireWildcard(require("./tag"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _default = {
  space,
  entry,
  asset,
  assetKey,
  contentType,
  locale,
  tag
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/contentful/dist/es-modules/entities/index.js
// module id = 322
// module chunks = 1